var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-message',{attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('b-spinner',{staticClass:"mb-4",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"variant":"primary"}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }